'use client';
import { cn } from '@wwe-portal/ui/lib/lib';

interface CompareVFXProps {
  className?: string;
  duration: number;
  from: 'left' | 'right';
}

export const CompareVFX = ({ className, duration, from }: CompareVFXProps) => {
  const sliderXPercent = from === 'left' ? 0 : 100;

  return (
    <div className={cn('overflow-hidden', className)}>
      <div
        className={cn('animate-in absolute top-0 z-30 m-auto h-full w-full', {
          'slide-in-from-left': from === 'left',
          'slide-in-from-right': from === 'right',
        })}
        style={{
          top: 0,
          right: `${sliderXPercent}%`,
          zIndex: 40,
          transitionProperty: 'right',
          transitionDuration: `${duration}ms`,
          animationDuration: `${duration}ms`,
          transitionTimingFunction: 'linear',
        }}
      >
        <div className="absolute right-0 top-0 h-full w-px bg-gradient-to-b from-transparent from-[5%] via-[#d2691e] to-transparent to-[95%]" />
        <div className="absolute right-0 top-1/2 z-20 h-full w-1/2 -translate-y-1/2 bg-gradient-to-l from-[#ffa500] to-transparent opacity-20 [mask-image:radial-gradient(100px_at_right,white,transparent)]" />
      </div>

      <div
        className={cn(
          'absolute left-0 top-0 z-[19] h-full w-full select-none bg-gradient-to-r from-black/60 to-black/0 mix-blend-darken duration-1000'
        )}
        style={{
          left: `${100 - sliderXPercent}%`,
          transitionProperty: 'left, opacity',
          transitionDuration: `${duration}ms`,
          transitionTimingFunction: 'linear',
        }}
      />
    </div>
  );
};
